/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

const state = {
    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: themeConfig.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: themeConfig.theme || 'light',
    navbarSearchAndPinList: navbarSearchAndPinList,
    AppActiveUser: {
        id: 0,
        name: 'John Doe',
        about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
        img: 'avatar-s-11.png',
        status: 'online',
    },

    themePrimaryColor: colors.primary,

    starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    userRole: null,
    //userModules:[],
  userModules: JSON.parse(localStorage.getItem("userModules")) || [],

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar component
    windowWidth: null,
    opData:"",
    patientId:'',
     ipNo: '', 
    opFlag:false,
    bookedRoomDetails:{
      roomId:"",
      roomNo:"",
      noofDays:"",
      bookedDate:"",
      rate:""
    },
    opList:[{"opNo":"1","opDate":'21-05-2020',"patientId":"1","patientName":"Praveen","patientPhoneNo":"9496846350","doctorName":"Dr Sameer Ahammad"}],
    savedOpData:{},
    billItems:[],
    doctorlist:[],
    opDashboardFilters: null,
    billDashboardFilters:null,
    patientDasboardFilters:null,
    receiptDasboardFilters:null,
    ipDasboardFilters:null,
   
  }

export default state
